import FeaturedItem from './FeaturedItem';
import compose from 'recompose/compose';
import mapProps from 'recompose/mapProps';
import { withModel } from '../../../data-providers/model';
import { localiseUrl } from 'src/common/utils/format-localised-url';

const enhance = compose(
  withModel,
  mapProps(props => ({
    reversed: props.reversed,
    backgroundColor: props.backgroundColor,
    image: props.reversed ? props.rightImages : props.leftImages,
    color: props.color,
    title: props.title,
    description: props.description,
    cta: props.cta,
    href: localiseUrl(props.model.countryModel, props.href)
  }))
);

export default enhance(FeaturedItem);



// WEBPACK FOOTER //
// ./src/client/js/view/components/FeaturedItems/FeaturedItem/index.js